(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD
    define(['underscore'], factory);
  } else if (typeof exports === 'object') {
    var _ = require('underscore');
    module.exports = factory(_);
  } else {
    throw 'Only AMD and CommonJS imports are supported.';
  }
}(this, function (_) {
  'use strict';

  /**
   * @class paymentDetailsUtils
   * @static
   */
  return {
    /**
     * Takes the form field value and returns true on valid number
     * Copied from https://gist.github.com/DiegoSalazar/4075533
     * @param value {String} the card number string
     * @return {Boolean} true if the number passes the Luhn Algorithm
     * @method isValidCardNumber
     */
    isValidCardNumber: function(value) {
      // accept only digits, dashes or spaces
      if (/[^0-9-\s]+/.test(value)) {
        return false;
      }
      // The Luhn Algorithm. It's so pretty.
      value = value.replace(/\D/g, '');

      var nCheck = 0;
      var nDigit = 0;
      var bEven = false;
      for (var n = value.length - 1; n >= 0; n--) {
        var cDigit = value.charAt(n);
        nDigit = parseInt(cDigit, 10);
        if (bEven && (nDigit *= 2) > 9) {
          nDigit -= 9;
        }
        nCheck += nDigit;
        bEven = !bEven;
      }
      return (nCheck % 10) === 0;
    },

    /**
     * Converts a javascript regex object to a javascript string
     * @param regex {Regex} a regex object
     * @return {String} a string representation of the regex without the starting / or ending /
     * @method convertRegexToString
     */
    convertRegexToString: function(regex) {
      var strRegex = '' + regex;
      return strRegex.substring(1, strRegex.length - 1);
    },

    /**
     * Takes the form field value and returns true on valid routing number
     * Copied from http://sandbox.michaelgrace.org/bank-routing-number-validation/
     * @param routing {String} the routing number string
     * @return {Boolean} true if the number passes the Checksum Algorithm
     * @method isValidRoutingNumber
     */
    isValidRoutingNumber: function(routing) {
      var checksumTotal, routingAsNumbers, sevenMultipleChecksumTotal, threeMultipleChecksumTotal, nineMultipleChecksumTotal, checksumMod,
          routingAsArrayOfCharacters = routing.split('');

      // validate digits so parsing doesn't fail below.
      if (/[^0-9]+/.test(routing)) {
        return false;
      }
      routingAsNumbers = _.map(routingAsArrayOfCharacters, function(character) {
        return parseInt(character, 10);
      });

      // The Checksum Algorithm.
      // http://en.wikipedia.org/wiki/Routing_transit_number#MICR_Routing_number_format
      sevenMultipleChecksumTotal = 7 * (routingAsNumbers[0] + routingAsNumbers[3] + routingAsNumbers[6]);
      threeMultipleChecksumTotal = 3 * (routingAsNumbers[1] + routingAsNumbers[4] + routingAsNumbers[7]);
      nineMultipleChecksumTotal = 9 * (routingAsNumbers[2] + routingAsNumbers[5] + routingAsNumbers[8]);
      checksumTotal = sevenMultipleChecksumTotal + threeMultipleChecksumTotal + nineMultipleChecksumTotal;

      checksumMod = checksumTotal % 10;
      return checksumMod === 0;
    }
  };
}));
